<template>
  <div
    class="c-section__contents-block trendMap"
    data-include-manual-download="trendWords"
  >
    <div class="l-block__header">
      <TitleSub level="h3">
        <span class="title"
          >上位ページのコンテンツに含まれる「単語」の傾向</span
        >
      </TitleSub>
    </div>
    <LoadingChara v-if="isLoading" variant="inline" size="sm">
      <template slot="title">
        データ取得中
      </template>
    </LoadingChara>
    <Error v-else-if="isError" variant="inline" size="sm">
      <template slot="title">
        データが取得できませんでした。<br />
        ページを再読み込みしてください。
      </template>
      <Button variant="border" size="w80" fsize="f11" @click="reload">
        <Icon variant="return_gn" :size="12" />
        リロード
      </Button>
    </Error>
    <template v-else>
      <div class="block-half">
        <SurveyTrendMap
          :keyword="keyword"
          :project="project"
          :words="resultWords"
        />
        <div class="graph-block bgGray">
          <ul class="graph-area graph-area__title">
            <li>
              <span class="word">単語</span> <span class="num">平均出現数</span
              ><span class="line"></span>
            </li>
          </ul>
          <div class="sticky_scroll">
            <perfect-scrollbar
              :options="{ suppressScrollX: true, minScrollbarLength: 10 }"
            >
              <ul class="graph-area graph-area__trendWords">
                <ListItemTrendWords
                  v-for="(item, index) in resultWords"
                  :key="index"
                  :item="item"
                  :max="max"
                />
              </ul>
            </perfect-scrollbar>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import Button from '@/components/Button';
import Error from '@/components/Error';
import Icon from '@/components/Icon';
import ListItemTrendWords from '@/components/contentPlans/ListItemTrendWords';
import LoadingChara from '@/components/LoadingChara';
import SurveyTrendMap from '@/components/contentPlans/SurveyTrendMap';
import TitleSub from '@/components/TitleSub';
import { PerfectScrollbar } from 'vue2-perfect-scrollbar';
import apiProjects from '@/api/projects';
import utils from '@/utils';
import axios from 'axios';

export default {
  props: ['createdAt', 'keyword', 'project', 'serpsTopItems'],

  components: {
    Button,
    Error,
    Icon,
    ListItemTrendWords,
    LoadingChara,
    PerfectScrollbar,
    SurveyTrendMap,
    TitleSub
  },

  data() {
    return {
      cnt: 0,
      flg: true,
      timeout: null,
      return: [],
      words: [],
      isError: false,
      isLoading: true
    };
  },

  computed: {
    max() {
      let max = 0;
      let count = this.resultWords.length;
      for (let i = 0; i < count; i++) {
        let index = this.resultWords[i].frequency;
        if (index > max) {
          max = index;
        }
      }
      return max;
    },
    resultWords() {
      let items = this.words;
      let array = [];
      let keys = [];
      let results = [];
      let serpsCount = this.serpsTopItems.length;

      for (let i = 0; i < items.length; i++) {
        if (items[i]) {
          for (let j = 0; j < items[i].length; j++) {
            array.push({
              text: items[i][j].text,
              frequency: items[i][j].frequency
            });
            keys.push(items[i][j].text);
          }
        }
      }
      keys = keys.filter(function(x, i, self) {
        return self.indexOf(x) === i;
      });

      for (let i = 0; i < keys.length; i++) {
        let result = {
          text: keys[i],
          frequency: 0
        };
        for (let j = 0; j < array.length; j++) {
          if (keys[i] === array[j].text) {
            result.frequency += array[j].frequency;
          }
        }
        results.push({
          text: keys[i],
          frequency: result.frequency / serpsCount
        });
      }
      // ソートして渡す
      results.sort(function(a, b) {
        if (a.frequency < b.frequency) {
          return 1;
        } else {
          return -1;
        }
      });
      return results.slice(0, 20);
    }
  },

  watch: {
    serpsTopItems: {
      handler() {
        this.init();
      },
      deep: true,
      immediate: true
    }
  },
  destroyed() {
    clearTimeout(this.timeout);

    // 非同期通信をキャンセル
    this.flg = false;
    for (let i = 0; i < this.return.length; i++) {
      if (this.return[i]) {
        this.return[i].cancel();
      }
    }
  },
  methods: {
    init() {
      if (!this.serpsTopItems.length) {
        return;
      }
      // 配列のコピー
      let serpsTopItems = JSON.parse(JSON.stringify(this.serpsTopItems));

      // URLの接尾辞が.pdfの場合は除外する
      serpsTopItems = serpsTopItems.filter(item => {
        return item.url && !utils.isPdf(item.url);
      });

      this.words = serpsTopItems.map(() => null);

      serpsTopItems.forEach((item, index) => {
        this.getContentsWords(item, index);
      });
    },
    getContentsWords(item, index) {
      let params = {
        dateJst: this.$options.filters.dateText(this.createdAt, 'YYYY-MM-DD'),
        device: 'desktop',
        url: item.url
      };
      this.return[index] = axios.CancelToken.source();

      return apiProjects.contentPlans.word
        .get(
          params,
          this.auth.idToken,
          this.project.id,
          this.return[index].token,
          index + 1
        )
        .then(response => {
          this.words.splice(index, 1, response.data.words);

          const isEmptyItems = this.words.some(item => item === null);
          if (!isEmptyItems) {
            this.$emit('completeTrendWords');
          }

          this.isLoading = false;
          // TrendWordsは全てのAPIが結果を返さなくても画面を表示できるのでLoadのフラグのみを返す
          this.$nextTick(() => {
            setTimeout(() => {
              this.$emit('loadedTrendWords');
            }, 20);
          });
        })
        .catch(error => {
          if (!axios.isCancel(error)) {
            this.scheduleGetSurvey(item, index);
          }
        });
    },
    scheduleGetSurvey(item, index) {
      if (this.flg) {
        if (this.cnt < 200) {
          this.timeout = setTimeout(() => {
            this.getContentsWords(item, index);
            this.cnt++;
          }, 30000);
        } else {
          this.isLoading = false;
          // TrendWordsは全てのAPIが結果を返さなくても画面を表示できるのでLoadのフラグのみを返す
          this.$nextTick(() => {
            setTimeout(() => {
              this.$emit('loadedTrendWords');
            }, 20);
          });
          this.isError = this.resultWords.length ? false : true;
        }
      }
    },
    reload() {
      location.reload(true);
    }
  }
};
</script>
